import React, { useState, useEffect } from "react";
import PageWrapper from "./components/PageWrapper";
import { useFormCtx } from "./FormContext";
import Button from "./components/Button";
import Splash from "./components/Splash";
import * as Const from "./_Const";
import * as Helper from "./_Helper";
import WarningPage from "./components/WarningPage";
import DebugPage from "./components/DebugPage";
import HiddenMenuBar from "./components/HiddenMenuBar";
import ScreenSaver from "./components/ScreenSaver";

const service_error_navbar_title = "Terminál mimo provoz";
const service_title = "Probíhá servis";
const service_subtitle = "Je nám líto, ale na tomto zařízení právě probíhá servis.\n\nVyčkejte příchodu zdravotnického personálu.";
const error_title = "Porucha";
const error_subtitle = "Je nám líto, ale toto zařízení je v poruše.\n\nVyčkejte příchodu zdravotnického personálu.";

function PageWelcome() {
  const { loaded, getPageData, navigateNext, terminalSettingsState, handleDebug, isDebugMode, storageUid, isInfoPanel } = useFormCtx();
  const [hidden, setHidden] = useState(true);
  const [hiddenHelp, setHiddenHelp] = useState(true);
  const isTerminal = Const.isTerminal();
  const index = Const.HOME_INDEX;
  const page = getPageData(index);

  const isMobileAndRegistrationEnabledOrTerminal = isTerminal ? true : !isTerminal && terminalSettingsState?.isMobileAppRegistrationEnabled ? true : false;
  const showClosed = loaded && !isDebugMode && terminalSettingsState?.isClosed && isMobileAndRegistrationEnabledOrTerminal ? true : false;
  const showErrorPage = loaded && isTerminal && !isDebugMode && terminalSettingsState?.isErrorPageEnabled ? true : false;
  const showServicePage = loaded && isTerminal && !isDebugMode && terminalSettingsState?.isServicePageEnabled ? true : false;
  const showMainPage = loaded && !showClosed && !isDebugMode && !showErrorPage && !showServicePage ? true : false;

  // console.log("xxx", terminalSettingsState);
  //console.log("xxx", "closed:" + showClosed, "mainPage:" + showMainPage, "errorPage:" + showErrorPage, "servicePage:" + showServicePage);

  //u terminalu vzdy a jinak jen kdyz neni loaded
  const showSplash = !loaded ? true : false;
  const showDebug = isTerminal && isDebugMode;
  const pageCss = isTerminal ? "mt-4 flex flex-col h-[65vh] bg-errora justify-center" : "mt-4 flex flex-col";
  //na terminalu nepoustet PING je to hodne vytezujici procesor20-30% i teplotu protoze to je na teto strance porad
  const buttonCss = isTerminal ? "font-bold text-6xl px-16 rounded-2xl mx-6 h-[60vh] " : "font-bold text-3xl px-16 rounded-2xl mx-6 h-32 ping";
  const textCss = isTerminal ? "text-lg" : "text-sm mt-4";
  //console.log(page);

  useEffect(() => {
    function scopedLoadData() {
      //v terminalu po nacteni preskocit na insert card
      if (isTerminal) {
        if (showMainPage) {
          if (isInfoPanel) {
            navigateNext(Const.PAGE_INFO_PANEL);
          } else {
            navigateNext(page?.nextRoute);
          }
        }
      }
    }

    scopedLoadData();
  }, [loaded, showDebug, showClosed]);

  return (
    <>
      {showSplash && <Splash />}
      {showDebug && (
        <PageWrapper title="Debug mode" index={index} showAppInfo={true} animate={false} onBackClick={() => window.location.reload()}>
          <DebugPage terminal={terminalSettingsState.terminalUID} uid={Helper.decrypt(storageUid)} keyNumber={terminalSettingsState.keyNumber} />
        </PageWrapper>
      )}
      {!isTerminal && showMainPage && (
        <PageWrapper title={page.title} index={index} showAppInfo={true}>
          <div className={pageCss}>
            <Button title="Registrace do systému" showIcon={false} onClick={() => navigateNext(page?.nextRoute)} className={buttonCss} />
          </div>

          <div className="mx-6">
            <p className={`${textCss} text-secondary font-light`}>
              Kliknutím na tlačítko <span className="uppercase font-medium italic">Registrace do systému</span> přejdete na další obrazovku
            </p>
            {!isTerminal && (
              <div>
                <p className="mt-12 text-2xl font-black text-accent-dark">O mobilní aplikaci</p>
                <p className="mt-0 text-lg font-light text-secondary">
                  Tato aplikace zjednodušuje proces registrace do pořadového systému ordinace pomocí mobilního telefonu.
                </p>

                <p className="mt-8 text-xl font-black text-accent-dark" onClick={() => setHidden(!hidden)}>
                  Výhody pro pacienta
                </p>
                {!hidden && (
                  <>
                    <p className="mt-0 text-lg font-light text-secondary">- Rychlost vyplnění registračních údajů</p>
                    <p className="mt-0 text-lg font-light text-secondary">- Není nutné nosit kartičku pojištěnce</p>
                    <p className="mt-0 text-lg font-light text-secondary">
                      - Bezpečně uložené registrační údaje pro příští návštěvu ve Vašem mobilním telefonu
                    </p>
                  </>
                )}
                <button className="text-bold uppercase text-sm mt-1 text-accent-dark" onClick={() => setHidden(!hidden)}>
                  {hidden ? "Více informací" : "Méně informací"}
                </button>

                <p className="mt-8 text-xl font-black text-accent-dark" onClick={() => setHiddenHelp(!hiddenHelp)}>
                  Postup při registraci
                </p>
                {!hiddenHelp && (
                  <>
                    <p className="mt-0 text-lg font-light text-secondary">
                      <span className="font-medium">1.</span> <span className="font-medium italic">Naskenujte QR kód</span> pomocí mobilního telefonu
                      připojeného k internetu <span className="font-medium italic">nebo přiložte telefon k NFC čipu</span> na registračním plakátu v ordinaci
                    </p>
                    <p className="mt-0 text-lg font-light text-secondary">
                      <span className="font-medium">2.</span> <span className="font-medium italic">Klikněte na</span> tlačítko
                      <span className="font-medium italic uppercase"> Registrace do systému</span> na hlavní stránce mobilní aplikace
                    </p>
                    <p className="mt-0 text-lg font-light text-secondary">
                      <span className="font-medium">3.</span> Pomocí tlačítek<span className="font-medium italic"> vyberte Důvod návštěvy</span>
                    </p>
                    <p className="mt-0 text-lg font-light text-secondary">
                      <span className="font-medium">4.</span>
                      <span className="font-medium italic">Vyplňte Vaše osobní údaje</span> potřebné pro registraci (veškerá osobní data se přenášejí a
                      uchovávají šifrovaně)
                    </p>
                    <p className="mt-0 text-lg font-light text-secondary">
                      <span className="font-medium">5.</span>
                      <span className="font-medium italic">Klikněte na</span> tlačítko <span className="font-medium italic">Registrovat</span> a posaďte se v
                      čekárně a čekejte na vyzvání
                    </p>
                  </>
                )}
                <button className="text-bold uppercase text-sm mt-1 text-accent-dark" onClick={() => setHiddenHelp(!hiddenHelp)}>
                  {hiddenHelp ? "Více informací" : "Méně informací"}
                </button>
              </div>
            )}
          </div>
        </PageWrapper>
      )}
      {isTerminal && <ScreenSaver />}
      {showClosed && <WarningPage index={index} message={terminalSettingsState.closedSubTitle} title={terminalSettingsState.closedTitle} warning="Zavřeno" />}
      {showErrorPage && <WarningPage index={index} message={error_subtitle} title={service_error_navbar_title} warning={error_title} />}
      {showServicePage && <WarningPage index={index} message={service_subtitle} title={service_error_navbar_title} warning={service_title} />}
      {isTerminal && <HiddenMenuBar />}
    </>
  );
}

export default PageWelcome;
